import React from "react";
import { Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useTemplateCategoryListQuery } from "../../graphql/templateCategory.hooks";

export const TemplateCategory = () => {
  const navigate = useNavigate();
  const { data: templateCategories, loading: templateCategoryLoading } =
    useTemplateCategoryListQuery();

  const moveToCreateForm = () => {
    navigate("/template/category/new");
  };

  if (templateCategoryLoading) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="mb-4">
          <h1>Template Category</h1>
        </div>
      </div>
      <div className="g-4 py-5 d-flex flex-column justify-content-center align-items-center bg-white rounded">
        <table className="col-11 mb-5">
          <thead>
            <tr>
              <th>Id</th>
              <th>Title</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {templateCategories.commonTemplateCategoryList.map(
              ({ id, title }: any) => (
                <tr key={id} style={{ lineHeight: "2.5", height: "50px" }}>
                  <td>{id}</td>
                  <td>{title}</td>
                  <td className="text-center">
                    <Link
                      to={`/template/category/${id}`}
                      className="text-primary me-4"
                      style={{ textDecoration: "none" }}
                    >
                      show
                    </Link>
                    <Link
                      to={`/template/category/${id}/edit`}
                      className="text-primary"
                      style={{ textDecoration: "none" }}
                    >
                      edit
                    </Link>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
        <button
          onClick={moveToCreateForm}
          className="btn btn-primary text-white col-6 col-md-2"
        >
          Create New
        </button>
      </div>
    </div>
  );
};
